<template>
  <el-table-column
    prop="representative_sale.receipt_number"
    sortable="custom"
    label="Kapcsolódó képviselői eladás"
    show-overflow-tooltip
    min-width="290"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.representative_sale"
        style="display: inline-block;"
      >
        <el-link
          type="primary"
          @click="openReceipt(scope.row)"
        >
          <i class="el-icon-printer"></i> {{ scope.row.representative_sale.receipt_number }}
        </el-link>
      </div>
      <el-tag v-else size="small" type="warning">Nincs kapcsolódó eladás</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'representative_sale.receipt_number',
    methods: {
      openReceipt(row) {
        window.open(row.representative_sale.receipt_file.path);
      },
    },
  };
</script>
